import { useEffect } from "react"
import { getStyleOverride } from "utils/geniusChatUtils"

type Props = {
  bottom?: number
  right?: number
  size?: number
}

export const useChatPosition = (props?: Props): void => {
  const { bottom = 16 } = props ?? { bottom: 16, right: 16, size: 64 }

  useEffect(() => {
    getStyleOverride().textContent = `
          #dg-chat-widget-launcher {
            bottom: ${bottom}px !important;
          }
          #dg-chat-widget {
            bottom: ${bottom}px !important;
          }
        `

    return () => {
      getStyleOverride().textContent = `
            #dg-chat-widget-launcher {
              bottom: 20px !important;
            }
            #dg-chat-widget {
              bottom: 20px !important;
            }
          `
    }
  })
}
